module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [(_vm.editKombox.id) ? _c('h3', [_vm._v(_vm._s('Kombox bearbeiten'))]) : _c('h3', [_vm._v(_vm._s('Neue Kombox anlegen'))]), _vm._v(" "), (false) ? _c('div', [_vm._v("\n               idCompany: " + _vm._s(_vm.editKombox.idCompany) + "\n               idUser: " + _vm._s(_vm.editKombox.idUser) + "\n             ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('form', {
    attrs: {
      "id": _vm._uid
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('cancel', _vm.kombox)
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "kombox-type"
    }
  }, [_vm._v("Art :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.type),
      expression: "editKombox.type"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "required": "",
      "id": "kombox-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editKombox, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.KomboxConf.TYPES), function(option) {
    return _c('option', {
      domProps: {
        "value": option.OPTION.VALUE,
        "textContent": _vm._s(option.OPTION.TEXT)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (['2', '3', '8', '10'].indexOf(_vm.editKombox.type) > -1),
      expression: "['2','3','8','10'].indexOf(editKombox.type) > -1"
    }],
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.subType),
      expression: "editKombox.subType"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "kombox-sub-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editKombox, "subType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.KomboxConf.SUBTYPES), function(option) {
    return _c('option', {
      domProps: {
        "value": option.OPTION.VALUE,
        "textContent": _vm._s(option.OPTION.TEXT)
      }
    })
  }), 0)]), _vm._v(" "), (['8', '9', '10'].indexOf(_vm.editKombox.type) > -1) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('label', {
    attrs: {
      "for": "zeiten"
    }
  }, [_vm._v("Zeiten :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.validTimes),
      expression: "editKombox.validTimes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "",
      "id": "zeiten",
      "placeholder": "13:00, 16:00, ...",
      "pattern": "^(([0-1][0-9])|(2[0-3])):[0-5][0-9](,[ ]?(([0-1][0-9])|(2[0-3])):[0-5][0-9])*"
    },
    domProps: {
      "value": (_vm.editKombox.validTimes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editKombox, "validTimes", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "acl"
    }
  }, [_vm._v("Rechte :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.acl),
      expression: "editKombox.acl"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "acl"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editKombox, "acl", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.KomboxConf.ACLS), function(option) {
    return _c('option', {
      domProps: {
        "value": option.OPTION.VALUE,
        "textContent": _vm._s(option.OPTION.TEXT)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "kb-modal-content"
    }
  }, [_vm._v("Inhalt :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.content),
      expression: "editKombox.content"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "kb-modal-content",
      "type": "text",
      "pattern": _vm.KomboxConf.TYPES[_vm.editKombox.type].CONTENT.PATTERN,
      "placeholder": _vm.KomboxConf.TYPES[_vm.editKombox.type].CONTENT.PLACEHOLDER,
      "title": _vm.KomboxConf.TYPES[_vm.editKombox.type].CONTENT.PLACEHOLDER
    },
    domProps: {
      "value": (_vm.editKombox.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editKombox, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "beschreibung"
    }
  }, [_vm._v("Beschreibung :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.description),
      expression: "editKombox.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "",
      "id": "beschreibung",
      "placeholder": "Tel"
    },
    domProps: {
      "value": (_vm.editKombox.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editKombox, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cc-versand"
    }
  }, [_vm._v("Versand :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editKombox.shippingActiv),
      expression: "editKombox.shippingActiv"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "cc-versand"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editKombox, "shippingActiv", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.KomboxConf.SHIPPING_ACTIV), function(option) {
    return _c('option', {
      domProps: {
        "value": option.OPTION.VALUE,
        "textContent": _vm._s(option.OPTION.TEXT)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editKombox.shippingActiv > 0),
      expression: "editKombox.shippingActiv > 0"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cc-datetime-shipping-begin"
    }
  }, [_vm._v("Versandbeginn :")]), _vm._v(" "), _c('cc-datetime', {
    attrs: {
      "label_id": "cc-datetime-shipping-begin"
    },
    model: {
      value: (_vm.editKombox.datetimeShippingBegin),
      callback: function($$v) {
        _vm.$set(_vm.editKombox, "datetimeShippingBegin", $$v)
      },
      expression: "editKombox.datetimeShippingBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editKombox.shippingActiv > 0),
      expression: "editKombox.shippingActiv > 0"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cc-datetime-shipping-end"
    }
  }, [_vm._v("Versandende :")]), _vm._v(" "), _c('cc-datetime', {
    attrs: {
      "label_id": "cc-datetime-shipping-end"
    },
    model: {
      value: (_vm.editKombox.datetimeShippingEnd),
      callback: function($$v) {
        _vm.$set(_vm.editKombox, "datetimeShippingEnd", $$v)
      },
      expression: "editKombox.datetimeShippingEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cc-datetime-begin"
    }
  }, [_vm._v("Beginn :")]), _vm._v(" "), _c('cc-datetime', {
    attrs: {
      "label_id": "cc-datetime-begin"
    },
    model: {
      value: (_vm.editKombox.datetimeBegin),
      callback: function($$v) {
        _vm.$set(_vm.editKombox, "datetimeBegin", $$v)
      },
      expression: "editKombox.datetimeBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cc-datetime-end"
    }
  }, [_vm._v("Ende :")]), _vm._v(" "), _c('cc-datetime', {
    attrs: {
      "label_id": "cc-datetime-end"
    },
    model: {
      value: (_vm.editKombox.datetimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.editKombox, "datetimeEnd", $$v)
      },
      expression: "editKombox.datetimeEnd"
    }
  })], 1)])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "form": _vm._uid
    }
  }, [_vm._v("\n              Speichern\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel', _vm.kombox)
      }
    }
  }, [_vm._v("\n              Abbrechen\n            ")]), _vm._v(" "), (_vm.editKombox.id) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('remove', _vm.kombox)
      }
    }
  }, [_vm._v("\n              Löschen\n            ")]) : _vm._e()])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b76e598!./~/vue-loader/lib/selector.js?type=template&index=0!./src/KomboxModal.vue
// module id = 282
// module chunks = 0